import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer(){
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <Link to="/dashboard" className="footer-brand">
          <span className="brand-emoji">🎭</span>
          <div>
            <div className="footer-title">Auditorium Hub</div>
            <div className="footer-sub">Clerk Dashboard</div>
          </div>
        </Link>

        <nav className="footer-links">
          <Link to="/events" className="footer-link">Events</Link>
          <Link to="/bookings" className="footer-link">Bookings</Link>
          <Link to="/reports" className="footer-link">Reports</Link>
          <Link to="/dashboard" className="footer-link">Clerk Dashboard</Link>
        </nav>
      </div>
      <div className="footer-copy">© {new Date().getFullYear()} Auditorium Hub</div>
    </footer>
  );
}


